import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  type ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { Bar, BarChart, XAxis, YAxis, CartesianGrid } from "recharts";

interface SessionTypeChartProps {
  data: {
    call: number;
    web_voice: number;
    web_chat: number;
  };
  loading?: boolean;
}

const chartConfig = {
  sessions: {
    label: "Sessions",
  },
  call: {
    label: "Phone Call",
    color: "var(--chart-1)",
  },
  web_voice: {
    label: "Web Voice",
    color: "var(--chart-2)",
  },
} satisfies ChartConfig;

export function SessionTypeChart({
  data,
  loading = false,
}: SessionTypeChartProps) {
  const chartData = [
    {
      type: "call",
      sessions: data.call,
      label: "Phone Call",
      fill: "var(--color-call)",
    },
    {
      type: "web_voice",
      sessions: data.web_voice,
      label: "Web Voice",
      fill: "var(--color-web_voice)",
    }
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Session Types</CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="h-[300px] w-full bg-muted animate-pulse rounded" />
        ) : (
          <ChartContainer config={chartConfig} className="h-[300px] w-full">
            <BarChart data={chartData} accessibilityLayer>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis
                dataKey="label"
                tickLine={false}
                tickMargin={10}
                axisLine={false}
              />
              <YAxis tickLine={false} axisLine={false} tickMargin={10} />
              <ChartTooltip content={<ChartTooltipContent />} />
              <Bar dataKey="sessions" radius={[8, 8, 0, 0]} fillOpacity={0.8} />
            </BarChart>
          </ChartContainer>
        )}
      </CardContent>
    </Card>
  );
}
